//import Login from "./Login.vue";
import Dashboard from "./Dashboard.vue";
import Reminder from "./Reminder.vue";
import Histories from "./histories/Histories.vue";
import PointHistories from "./histories/PointHistories.vue";
import Results from "./results/Results.vue";
import Tree from "./results/Tree.vue";
import Archives from "./Archives.vue";
import AppSettings from "./AppSettings.vue";
import Cancel from "./cancel/CancelStart.vue";
import CancelConfirm from "./cancel/CancelConfirm.vue";
import CancelEnd from "./cancel/CancelEnd.vue";
import NotFound from "./404.vue";
import QA from "./QA.vue";
import PostpaidQA from "./PostpaidQA.vue";
import ReusebottleRefill from "./lp/ReusebottleRefill.vue";
import FoamingBodySoap from "./lp/FoamingBodySoap.vue";
import MscSeminar from "./lp/MscSeminar.vue";
import MscSeminar2023 from "./lp/MscSeminar2023.vue";
import Invoice from "./lp/Invoice.vue";
import ManavisCollege from "./lp/ManavisCollege.vue";
import ManavisCollegeEntry from "./lp/ManavisCollegeEntry.vue";
import Campaign20230410_1 from "./lp/Campaign20230410_1.vue";
import Campaign20230410_2 from "./lp/Campaign20230410_2.vue";
import Campaign20230410_3 from "./lp/Campaign20230410_3.vue";
import Campaign20241023 from "./lp/Campaign20241023.vue";
import OmotenashiSelection2024 from "./lp/OmotenashiSelection2024.vue";
import Supplementplus20250114 from "./lp/Supplementplus20250114.vue";
import Homeicon from "./lp/Homeicon.vue";
import HomeiconIphone from "./lp/HomeiconIphone.vue";
import HomeiconAndroid from "./lp/HomeiconAndroid.vue";
import Manavisfesta202505 from "./lp/Manavisfesta202505.vue";
import VitamindPlus from "./lp/VitamindPlus.vue";
import AppEndOfService from "./AppEndOfService.vue";
import ShoppingGuide from "./ShoppingGuide.vue";
import Column202306 from "./column/Column202306.vue";
import Column202307 from "./column/Column202307.vue";
import Column202308 from "./column/Column202308.vue";
import Column202309 from "./column/Column202309.vue";
import Column202310 from "./column/Column202310.vue";
import Column202311 from "./column/Column202311.vue";
import Column202312 from "./column/Column202312.vue";
import Column202402 from "./column/Column202402.vue";
import Column202403 from "./column/Column202403.vue";
import Column202405 from "./column/Column202405.vue";
import Column202407 from "./column/Column202407.vue";
import Column202408 from "./column/Column202408.vue";
import Column202410 from "./column/Column202410.vue";
import Column202411 from "./column/Column202411.vue";
import Column202412 from "./column/Column202412.vue";
import Column202501 from "./column/Column202501.vue";
import Column202502 from "./column/Column202502.vue";
import Column202503 from "./column/Column202503.vue";
import Column202504 from "./column/Column202504.vue";
import Column202505 from "./column/Column202505.vue";
import Column202506 from "./column/Column202506.vue";
import Column2025Special from "./column/Column2025Special.vue";
import Column202509 from "./column/Column202509.vue";
import Column202509_2 from "./column/Column202509_2.vue";
import Column202510 from "./column/Column202510.vue";
import Column202601 from "./column/Column202601.vue";
import Column202602 from "./column/Column202602.vue";
import Column202603 from "./column/Column202603.vue";
import Album202511 from "./lp/Album202511.vue";
import TMF2026 from "./lp/TMF2026.vue";
import TMF2026_album from "./lp/TMF2026_album.vue";
import TMF2026_speech from "./lp/TMF2026_speech.vue";

export default {
  routes: [
    {
      path: "/login",
      redirect: '/dashboard' 
    },
    {
      path: "/dashboard",
      component: Dashboard,
    },
    {
      path: "/reminder",
      component: Reminder,
    },
    {
      path: "/histories",
      component: Histories,
    },
    {
      path: "/pointhistories",
      component: PointHistories,
    },
    {
      path: "/results",
      component: Results,
    },
    {
      path: "/results/:tab",
      component: Tree,
    },
    {
      path: "/archives",
      component: Archives,
    },
    {
      path: "/appsettings",
      component: AppSettings,
    },
    {
      path: "/cancel",
      component: Cancel,
    },
    {
      path: "/cancel/confirm",
      component: CancelConfirm,
    },
    {
      path: "/cancel/end",
      component: CancelEnd,
    },
    {
      path: "/:catchAll(.*)",
      component: NotFound,
    },
    {
      path: "/qa",
      component: QA,
    },
    {
      path: "/postpaid-qa",
      component: PostpaidQA,
    },
    {
      path: "/lp/reusebottle-refill",
      component: ReusebottleRefill,
    },
    {
      path: "/lp/foamingbodysoap",
      component: FoamingBodySoap,
    },
    {
      path: "/lp/msc-seminar",
      component: MscSeminar,
    },
    {
      path: "/lp/msc-seminar-2023",
      component: MscSeminar2023,
    },
    {
      path: "/lp/invoice",
      component: Invoice,
    },
    {
      path: "/lp/manavis-college",
      component: ManavisCollege,
    },
    {
      path: "/lp/manavis-college-entry",
      component: ManavisCollegeEntry,
    },
    {
      path: "/lp/thanks2023",
      component: Campaign20230410_1,
    },
    {
      path: "/lp/ouen2023",
      component: Campaign20230410_2,
    },
    {
      path: "/lp/starter2023",
      component: Campaign20230410_3,
    },
    {
      path: "/lp/manavisfesta2024",
      component: Campaign20241023,
    },
    {
      path: "/lp/omotenashiselection2024",
      component: OmotenashiSelection2024,
    },
    {
      path: "/lp/supplementplus202501",
      component: Supplementplus20250114,
    },
    {
      path: "/lp/homeicon",
      component: Homeicon,
    },
    {
      path: "/lp/homeicon-iphone",
      component: HomeiconIphone,
    },
    {
      path: "/lp/homeicon-android",
      component: HomeiconAndroid,
    },
    {
      path: "/lp/manavisfesta202505",
      component: Manavisfesta202505,
    },
    {
      path: "/lp/vitamin-d-plus",
      component: VitamindPlus,
    },
    {
      path: "/app-end-of-service",
      component: AppEndOfService,
    },
    {
      path: "/shoppingguide",
      component: ShoppingGuide,
    },
    {
      path: "/column/column-202306",
      component: Column202306,
    },
    {
      path: "/column/column-202307",
      component: Column202307,
    },
    {
      path: "/column/column-202308",
      component: Column202308,
    },
    {
      path: "/column/column-202309",
      component: Column202309,
    },
    {
      path: "/column/column-202310",
      component: Column202310,
    },
    {
      path: "/column/column-202311",
      component: Column202311,
    },
    {
      path: "/column/column-202312",
      component: Column202312,
    },
    {
      path: "/column/column-202402",
      component: Column202402,
    },
    {
      path: "/column/column-202403",
      component: Column202403,
    },
    {
      path: "/column/column-202405",
      component: Column202405,
    },
    {
      path: "/column/column-202407",
      component: Column202407,
    },
    {
      path: "/column/column-202408",
      component: Column202408,
    },
    {
      path: "/column/column-202410",
      component: Column202410,
    },
    {
      path: "/column/column-202411",
      component: Column202411,
    },
    {
      path: "/column/column-202412",
      component: Column202412,
    },
    {
      path: "/column/column-202501",
      component: Column202501,
    },
    {
      path: "/column/column-202502",
      component: Column202502,
    },
    {
      path: "/column/column-202503",
      component: Column202503,
    },
    {
      path: "/column/column-202504",
      component: Column202504,
    },
    {
      path: "/column/column-202505",
      component: Column202505,
    },
    {
      path: "/column/column-202506",
      component: Column202506,
    },
    {
      path: "/column/column-2025special",
      component: Column2025Special,
    },
    {
      path: "/column/column-202509",
      component: Column202509,
    },
    {
      path: "/column/column-202509-2",
      component: Column202509_2,
    },
    {
      path: "/column/column-202510",
      component: Column202510,
    },
    {
      path: "/lp/album-202511",
      component: Album202511,
    },
    {
      path: "/lp/tmf2026",
      component: TMF2026,
    },
    {
      path: "/lp/TMF2026",
      component: TMF2026,
    },
    {
      path: "/lp/tmf2026_album",
      component: TMF2026_album,
    },
    {
      path: "/lp/tmf2026_speech",
      component: TMF2026_speech,
    },
    {
      path: "/column/column-202601",
      component: Column202601,
    },
    {
      path: "/column/column-202602",
      component: Column202602,
    },
    {
      path: "/column/column-202603",
      component: Column202603,
    }
  ],
};
